import {
  ComponentStateManager,
  DataVizContainerCommonUtils,
} from '../../../common/types';
import { getLineChartDataFromOverTimeUnsegmentedResponse } from '../../over-time-unsegmented-utils';
import {
  OverTimeUnsegmentedVizData,
  OverTimeUnsegmentedVizExternalProps,
} from '../../types';
import {
  OverTimeUnsegmentedLineChartActions,
  OverTimeUnsegmentedLineChartState,
  OverTimeUnsegmentedLineChartUiComponentProps,
} from './types';

export const overTimeUnsegmentedLineChartDataToUiComponentProps = (
  data: OverTimeUnsegmentedVizData,
  externalProps: OverTimeUnsegmentedVizExternalProps,
  componentStateManager: ComponentStateManager<
    OverTimeUnsegmentedLineChartState,
    OverTimeUnsegmentedLineChartActions
  >,
  { t }: DataVizContainerCommonUtils
): OverTimeUnsegmentedLineChartUiComponentProps => {
  const { dataResponse, titleConfig, metricDisplayValues, metricDetailsMap } =
    data;
  const chartData = getLineChartDataFromOverTimeUnsegmentedResponse(
    dataResponse,
    metricDisplayValues,
    metricDetailsMap,
    t
  );
  const displayConfig = {
    ...componentStateManager.state.displayState,
    ...componentStateManager.actions.displayActions,
  };

  return {
    fullScreenHandle: externalProps.fullScreenHandle,
    displayConfig,
    titleConfig,
    chartData,
    chartColors: data.chartColors,
  };
};
